import { render } from "./NewDonorEducationalPamphlet.vue?vue&type=template&id=dd834444"
import script from "./NewDonorEducationalPamphlet.vue?vue&type=script&lang=js"
export * from "./NewDonorEducationalPamphlet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__